<!--  -->
<template>
  <div>
    <div class='open-account mt-16'>
      <div class="box" v-for="(item, index) in tab" :key="item.id">
        <div class="box_round">0{{ index + 1 }}</div>
        <div class="box_title">{{ item.title }}</div>
        <div class="box_label">{{ item.description }}</div>
      </div>
    </div>
    <!-- <el-steps direction="vertical" :active="4">
      <el-step :title="item.title" v-for="(item, index) in tab" :key="index" :description="item.description"></el-step>
    </el-steps> -->
  </div>
</template>

<script>

export default {
  props: {
    tab: {
      type: Array,
      default: () => []
    }
  }
}
</script>
<style scoped lang='scss'>
.open-account {
  display: flex;
  justify-content: space-around;

  .box {
    text-align: center;
    width: 25%;
    padding: 0 1rem;

    .box_round {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: linear-gradient(90deg, #4A6690 0%, #AF6BC2 100%);
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-size: 20px;
      margin: 0 auto;
    }

    .box_title {
      font-weight: bold;
      font-size: 20px;
      color: #18181B;
      margin-top: 1rem;
    }

    .box_label {
      font-size: 16px;
      color: #555555;
      margin-top: 1rem;
    }
  }
}

@media screen and (max-width: 768px) {
  .open-account {
    flex-wrap: wrap;
    flex-direction: column;

    .box {
      width: 100%;
      margin-bottom: 2rem;
    }
  }

  ::v-deep .el-step__title.is-finish {
    color: #000;
    font-weight: bold;
  }

  ::v-deep .el-step__description.is-finish {
    color: #555555;
    font-size: 0.9rem;
    margin-bottom: 30px;
  }

  ::v-deep .el-step__head.is-finish {
    color: #4A6690
  }
}
</style>
